export default __webpack_public_path__ + "static/media/simple-icon.b0421e1d.svg";